export default "__VITE_ASSET__DBUylLAQ__"